import React from 'react'

export default function PlayIcon({
  className = 'text-yellow-100',
  width = 8,
  height = 10,
}) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.13722 5.34305L1.24059 9.2741C1.11276 9.35934 0.940045 9.32479 0.854823 9.19699C0.824362 9.15126 0.808105 9.09757 0.808105 9.04266V1.18052C0.808105 1.02688 0.932651 0.902344 1.08628 0.902344C1.1412 0.902344 1.1949 0.918601 1.24059 0.949061L7.13722 4.88011C7.26501 4.96534 7.29956 5.13809 7.21433 5.26589C7.19397 5.29643 7.16776 5.32269 7.13722 5.34305Z" fill="currentColor"/>
    </svg>
  )
}
